import { Injectable, EventEmitter } from '@angular/core';
import { Storage } from '@ionic/storage';

import { ApiService } from './api.service';
import { API } from '../../config';

import { Observable, from } from 'rxjs';

@Injectable()
export class AuthService {
    refreshCalled = false;
    hasToken = new EventEmitter();

    constructor(private api: API, private apiService: ApiService, private storage: Storage) {}

    setToken(user: string, token: string, statut: string): Promise<any> {
        return this.storage.set('token', {user, token, statut});
    }

    getToken(): Promise<any> {
        return this.storage.get('token');
    }

    removeToken(): any {
        this.storage.remove('token');
        this.hasToken.emit(false);
    }

    setRefreshToken(token): Promise<any> {
        return this.storage.set('refresh_token', token);
    }

    getRefreshToken(): Promise<any> {
        return this.storage.get('refresh_token');
    }

    removeRefreshToken(): any {
        this.storage.remove('refresh_token');
    }

    login(body: any): Observable<any> {
        return from(this.apiService.post(this.api.URLS.authentification, "username=" + body._username + "&password=" + body._password + "&AuthenticationMode=" + body._authenticationMode + "&grant_type=password"));
    }

    refresh(refreshToken): Observable<any> {
        return from(this.apiService.post(this.api.URLS.authentification, "refresh_token=" + refreshToken + "&grant_type=refresh_token"));
    }

    mdpOublie(body: any): Observable<any> {
        return from(this.apiService.get(this.api.URLS.mdpOublie + "?username=" + body._username));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts